// extracted by mini-css-extract-plugin
module.exports = {"background":"BlogPosts_background__juW2e","header":"BlogPosts_header__LaWQ_","show-more-button":"BlogPosts_show-more-button__FKyYO"};